import { makeVar } from '@apollo/client';
import { ReactiveVariable, useReactiveVariable } from 'src/helpers/reactiveVariables';

export const linkedBidsSearchArgsVar = makeVar<string | undefined>(undefined);
export function useLinkedBidsSearchArgs(): ReactiveVariable<string | undefined> {
  return useReactiveVariable<string | undefined>(linkedBidsSearchArgsVar);
}

export default useLinkedBidsSearchArgs;
